import { useRef, useImperativeHandle, forwardRef } from 'react';
import { useHistory } from 'react-router';
import styled from 'styled-components';

import { useLanguage } from '../../../Context/LanguageContext';

import CompletePermuteLogoPath from '../../../image/CompletePermuteLogo.png';

const CompletePermuteView = forwardRef((props, ref) => {
  const history = useHistory();
  const { t } = useLanguage();

  const TopLevelRef = useRef();

  useImperativeHandle(ref, () => ({
    setOpacity: () => {
      TopLevelRef.current.style.zIndex = 3;
      TopLevelRef.current.style.opacity = 1;
    }
  }));

  return (
    <TopLevelWrapper ref={TopLevelRef}>
      <InfoBox>
        <Logo src={CompletePermuteLogoPath}/>
        <InfoWrapper>
          <Title>{t('findAccount.pwResetComplete1', { name: sessionStorage.getItem('name') })}</Title>
          <Title>{t('findAccount.pwResetComplete2')}</Title>
          <LoginButton onClick={() => history.push('/')}>
            <LoginButtonText>{t('findAccount.goLogin')}</LoginButtonText>
          </LoginButton>
        </InfoWrapper>
      </InfoBox>
    </TopLevelWrapper>
  )
});

export default CompletePermuteView;

const TopLevelWrapper = styled.div`
  position: absolute;

  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  opacity: 0;
  z-index: -1;

  transition: all 0.5s ease-in-out;
`;

const Logo = styled.img`
  width: 120px;
  height: 120px;

  margin-top: -115px;
`;

const InfoBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: max(351px, 30.3125vw);
  height: 288px;

  border-radius: 50px;
  background-color: #FFFFFF;
  box-shadow: 0px 40px 50px rgba(240, 232, 227, 0.5);
`;

const InfoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  margin-top: 32px;
`;

const Title = styled.p`
  font-family: NotoSansKR-Regular;
  font-size: 18px;

  color: #000000;

  margin: 0 0 0 0;
`;

const LoginButton = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 135px;
  height: 46px;

  margin-top: 40px;

  background-color: #FF8B48;
  border-radius: 23px;

  transition: all 0.5s ease-in-out;

  &:hover {
    cursor: pointer;
    background-color: #FF7322;
  }
`;

const LoginButtonText = styled.p`
  font-family: NotoSansKR-Bold;
  font-size: 14px;

  color: #FFFFFF;
  margin: 0 0 0 0;

  &:hover {
    cursor: pointer;
  }
`;
